// src/utils/darkenColor.js

/**
 * Darken a hex color by a given percentage
 * @param {string} color - Hex color (e.g., "#ff9900")
 * @param {number} percent - Percentage to darken (default 10)
 * @returns {string} Darkened hex color
 */
const darkenColor = (color, percent = 10) => {
  if (!color || typeof color !== "string") return color;

  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const G = (num >> 8 & 0x00FF) - amt;
  const B = (num & 0x0000FF) - amt;

  return "#" + (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  ).toString(16).slice(1);
};

export default darkenColor;
